import React, { useState, useEffect } from 'react';
import Footerdiv from "../layout/footer.js";
import Headerdiv from "../layout/header.js";
import {
  Layout,
  Typography,
  Descriptions,
  Space,
  Breadcrumb,
  Spin,
  Tag,
  Row,
  Table,
  Button,
  Col,
  Popconfirm,
} from 'antd';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings.js';
import { AlertError, AlertSuccess } from '../usableclasses.js';

const { Content } = Layout;

// Define distinct colors for each section header
const sectionColors = {
  userInfo: '#1890ff',            // blue
  monthlyPoints: '#52c41a',       // green
  bankInfo: '#fa8c16',            // orange
  shippingBilling: '#722ed1',     // purple
  parentSponsor: '#eb2f96',       // pink
  teamMembers: '#13c2c2'          // cyan
};

const UserView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");

  const [mlmUser, setMlmUser] = useState(null);

  const [mlmUserChildConsult, setMlmUserChildConsult] = useState([]);

  const [mlmUserParent_consultantId, setMlmUserParent_consultantId] = useState(null);
  const [mlmUserParent_firstName, setMlmUserParent_firstName] = useState(null);
  const [mlmUserParent_secondName, setMlmUserParent_secondName] = useState(null);
  const [mlmUserParent_selfEarnPoints, setMlmUserParent_selfEarnPoints] = useState(0);
  const [mlmUserParent_contributePoints, setMlmUserParent_contributePoints] = useState(0);
  const [mlmUserParent_contributeBV, setMlmUserParent_contributeBV] = useState(0);
  const [mlmUserParent_totalBV, setMlmUserParent_totalBV] = useState(0);
  const [mlmUserParent_groupBV, setMlmUserParent_groupBV] = useState(0);
  const [mlmUserParent_selfBV, setMlmUserParent_selfBV] = useState(0);

  const [loading, setLoading] = useState(true);

  const fetchMlmUserDetails = async () => {
    try {
      const response = await axios.post(`${ApiURL}/erp/mlmuser/getdetail`,
        { userId: id },
        { headers: { SystemAccessToken: TOKEN } }
      );
      if (response.data) {
        setMlmUser(response.data);
      } else {
        AlertError('Failed to load MLM user details');
      }
    } catch (error) {
      AlertError('Error fetching MLM user data');
    } finally {
      setLoading(false);
    }
  };

  const fetchMlmUserMapDetails = async () => {
    try {
      const response = await axios.post(`${ApiURL}/erp/mlmuser/getusermapdetail`,
        { userId: id },
        { headers: { SystemAccessToken: TOKEN } }
      );
      if (response.data) {

        setMlmUserParent_consultantId(response.data.consultantId);
        setMlmUserParent_firstName(response.data.firstName);
        setMlmUserParent_secondName(response.data.secondName);
        setMlmUserParent_selfEarnPoints(response.data.selfEarnPoints);
        setMlmUserParent_contributePoints(response.data.contributePoints);
        setMlmUserParent_contributeBV(response.data.contributeBv);
        setMlmUserParent_totalBV(response.data.totalPoints);
        setMlmUserParent_selfBV(response.data.selfEarnBv);
        setMlmUserParent_groupBV(response.data.totalBv);

        setMlmUserChildConsult(response.data.childConsultants);
      } else {
        AlertError('Failed to load MLM user details');
      }
    } catch (error) {
      AlertError('Error fetching MLM user data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchMlmUserDetails();
    if (id) fetchMlmUserMapDetails();

  }, [id, ApiURL, TOKEN]);

  const getBoolText = (value) => value ? "Yes" : "No";

  // Define columns for the Ant Design Table
  const childConsultantColumns = [
    {
      title: 'Consult ID',
      dataIndex: 'consultantId',
      key: 'consultantId',
      render: (text) => <Link to={`/mlm/userview/${text}`}>{text}</Link>,
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Second Name',
      dataIndex: 'secondName',
      key: 'secondName',
    },
    {
      title: 'Self Points',
      dataIndex: 'selfEarnPoints',
      key: 'selfEarnPoints',
    },
    {
      title: "Self BV",
      dataIndex: "selfEarnBv",
      key: "selfEarnBv"
    },
    {
      title: 'Commission Points',
      dataIndex: 'contributePoints',
      key: 'contributePoints',
    },
    {
      title: "Commission BV",
      dataIndex: "contributeBv",
      key: "contributeBv"
    },
    {
      title: 'Group Points',
      dataIndex: 'totalPoints',
      key: 'totalPoints',
    },
    {
      title: "Group BV",
      dataIndex: "totalBv",
      key: "totalBv"
    }
  ];

  const downloadFile = async (file) => {
    try {
      const headers = {
        SystemAccessToken: TOKEN,
      }
      const response = await axios.post(`${ApiURL}/erp/mlmuser/downloadfile`, { fileName: file }, { responseType: 'blob', headers }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.log(error)
      AlertError('Error downloading file');
    }
  }

  const verifyOrUnverifyUserDetails = async (status) => {
    try {
      setLoading(true)
      const headers = {
        SystemAccessToken: TOKEN,
      }
      if (status) {
        const res = await axios.get(`${ApiURL}/erp/mlmuser/profilemarkasunverified/${id}`, { headers })
        if (res.data) {
          fetchMlmUserDetails()
          fetchMlmUserMapDetails()
          AlertSuccess("Profile Updated Successfully")
        } else {
          AlertError("Profile Update Failed")
        }
      } else {
        const res = await axios.get(`${ApiURL}/erp/mlmuser/profilemarkasverified/${id}`, { headers })
        if (res.data) {
          fetchMlmUserDetails()
          fetchMlmUserMapDetails()
          AlertSuccess("Profile Updated Successfully")
        } else {
          AlertError("Profile Update Failed")
        }
      }
    } catch (error) {
      console.log(error)
      AlertError("Profile Update Failed")
    } finally {
      setLoading(false)
    }
  }

  const verifyOrUnverifyBankDetails = async (status) => {
    try {
      setLoading(true)
      const headers = {
        SystemAccessToken: TOKEN,
      }
      if (status) {
        const res = await axios.get(`${ApiURL}/erp/mlmuser/bankmarkasunverified/${id}`, { headers })
        if (res.data) {
          fetchMlmUserDetails()
          fetchMlmUserMapDetails()
          AlertSuccess("Profile Updated Successfully")
        } else {
          AlertError("Profile Update Failed")
        }
      } else {
        const res = await axios.get(`${ApiURL}/erp/mlmuser/bankmarkasverified/${id}`, { headers })
        if (res.data) {
          fetchMlmUserDetails()
          fetchMlmUserMapDetails()
          AlertSuccess("Profile Updated Successfully")
        } else {
          AlertError("Profile Update Failed")
        }
      }
    } catch (error) {
      console.log(error)
      AlertError("Profile Update Failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
      <Headerdiv />
      <Content style={{ padding: '10px' }}>

        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item><Link to={'/mlm/userlist'}>MLM User</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Account Detail View</Breadcrumb.Item>
        </Breadcrumb>

        <div style={{ padding: 20, minHeight: '65vh', background: '#fff', borderRadius: '10px' }}>
          <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
                <div style={{ marginTop: 16 }}>Loading MLM User details...</div>
              </div>
            ) : mlmUser ? (
              <>
                <Descriptions
                  bordered
                  column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }}
                  title={<span style={{ color: sectionColors.userInfo, fontWeight: 'bold' }}>User Information</span>}
                  extra={
                    <Button type="primary" onClick={() => navigate(`/mlm/userlist/edit/${id}`)}>
                      Edit User
                    </Button>
                  }
                  layout="vertical"
                  size="small"
                >
                  <Descriptions.Item label={<strong>Consult ID</strong>}>{mlmUser.mlM_CONSULTID}</Descriptions.Item>
                  <Descriptions.Item label={<strong>First Name</strong>}>{mlmUser.mlM_FIRSTNAME || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Last Name</strong>}>{mlmUser.mlM_SECONDNAME || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Mobile No</strong>}>{mlmUser.mlM_USERMOBILE}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Email</strong>}>{mlmUser.mlM_USEREMAIL || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Doc Type</strong>}>{mlmUser.mlM_REGDOCTYPE}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Doc No</strong>}>
                    <Row align={'middle'} gutter={16}>
                      <Col>{mlmUser.mlM_REGDOCNO}</Col>
                      {mlmUser.mlM_REGDOCFILE && (
                        <Col>
                          <Button onClick={() => downloadFile(mlmUser.mlM_REGDOCFILE)} size='small' type="primary">
                            Download
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </Descriptions.Item>
                  <Descriptions.Item label={<strong>Doc Verified</strong>}>{getBoolText(mlmUser.mlM_REGDOCVERIFY === 'True')}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Need Password Reset</strong>}>{getBoolText(mlmUser.mlM_NEEDPWRESET)}</Descriptions.Item>
                  <Descriptions.Item label={<strong>User Verified</strong>}>{getBoolText(mlmUser.mlM_USERVERIFY)}</Descriptions.Item>
                  <Descriptions.Item label={<strong>User Active</strong>}>{getBoolText(mlmUser.mlM_USERACTIVE)}</Descriptions.Item>
                  <Descriptions.Item label={<strong>User Deleted</strong>}>{getBoolText(mlmUser.mlM_USERDELETE)}</Descriptions.Item>
                </Descriptions>
                <Popconfirm
                  title={`Are you sure you want to mark this user as ${mlmUser.mlM_REGDOCVERIFY === "True" ? 'unverified' : 'verified'}?`}
                  okType="danger"
                  okText="Yes"
                  cancelText="No"
                  placement="topRight"
                  onConfirm={() => verifyOrUnverifyUserDetails(mlmUser.mlM_REGDOCVERIFY === "True" ? true : false)}
                >
                  <Button
                    type={mlmUser.mlM_REGDOCVERIFY === "True" ? "default" : "primary"}
                    danger={mlmUser.mlM_REGDOCVERIFY === "True"}
                  >
                    {mlmUser.mlM_REGDOCVERIFY === "True" ? "Mark User As Unverified" : "Mark User As Verified"}
                  </Button>
                </Popconfirm>
                <Descriptions
                  bordered
                  column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }}
                  title={<span style={{ color: sectionColors.monthlyPoints, fontWeight: 'bold' }}>Monthly Points & Wallet</span>}
                  layout="vertical"
                  size="small"
                >
                  <Descriptions.Item label={<strong>Self Points</strong>}>{mlmUser.mlM_MONTHSELFPONIT || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Commission Point</strong>}>{mlmUser.mlM_MONTHCOMMPONIT || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Group Points</strong>}>{mlmUser.mlM_MONTHGROUPPONIT || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Self BV</strong>}>{mlmUser.mlM_MONTHSELFBV || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Commission BV</strong>}>{mlmUser.mlM_MONTHCOMMBV || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Group BV</strong>}>{mlmUser.mlM_MONTHGROUPBV || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Wallet Balance</strong>}>{mlmUser.mlM_MONTHWALLETBALANCE || "-"}</Descriptions.Item>
                </Descriptions>

                <Descriptions
                  bordered
                  column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  title={<span style={{ color: sectionColors.bankInfo, fontWeight: 'bold' }}>Bank Information</span>}
                  layout="vertical"
                  size="small"
                >
                  <Descriptions.Item label={<strong>Bank Name</strong>}>{mlmUser.mlM_BANKNAME || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Branch Name</strong>}>{mlmUser.mlM_BRANCHNAME || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Account No</strong>}>
                    <Row align={'middle'} gutter={16}>
                      <Col>{mlmUser.mlM_BANKACCNO}</Col>
                      {mlmUser.mlM_BANKDOCFILE && (
                        <Col>
                          <Button size='small' type="primary" onClick={() => downloadFile(mlmUser.mlM_BANKDOCFILE)}>
                            Download
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </Descriptions.Item>
                  <Descriptions.Item label={<strong>Account Name</strong>}>{mlmUser.mlM_BANKACCNAME || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Bank Doc Verified</strong>}>{getBoolText(mlmUser.mlM_BANKVERIFY === 'True')}</Descriptions.Item>
                </Descriptions>
                <Popconfirm
                  title={`Are you sure you want to mark this bank details as ${mlmUser.mlM_BANKVERIFY === "True" ? 'unverified' : 'verified'}?`}
                  okType="danger"
                  okText="Yes"
                  cancelText="No"
                  placement="topRight"
                  onConfirm={() => verifyOrUnverifyBankDetails(mlmUser.mlM_BANKVERIFY === "True" ? true : false)}
                >
                  <Button
                    type={mlmUser.mlM_BANKVERIFY === "True" ? "default" : "primary"}
                    danger={mlmUser.mlM_BANKVERIFY === "True"}
                  >
                    {mlmUser.mlM_BANKVERIFY === "True" ? "Mark Bank As Unverified" : "Mark Bank As Verified"}
                  </Button>
                </Popconfirm>
                <Descriptions
                  bordered
                  column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  title={<span style={{ color: sectionColors.shippingBilling, fontWeight: 'bold' }}>Shipping & Billing Information</span>}
                  layout="vertical"
                  size="small"
                >
                  <Descriptions.Item label={<strong>Billing Address 1</strong>}>{mlmUser.mlM_BILLADDR1 || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Billing Address 2</strong>}>{mlmUser.mlM_BILLADDR2 || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Billing City</strong>}>{mlmUser.mlM_BILLCITY || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Billing District</strong>}>{mlmUser.mlM_BILLDISTRICT || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Shipping Address 1</strong>}>{mlmUser.mlM_SHIPADDR1 || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Shipping Address 2</strong>}>{mlmUser.mlM_SHIPADDR2 || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Shipping City</strong>}>{mlmUser.mlM_SHIPCITY || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Shipping District</strong>}>{mlmUser.mlM_SHIPDISTRICT || "-"}</Descriptions.Item>
                </Descriptions>

                <hr />

                <Descriptions
                  bordered
                  column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }}
                  title={<span style={{ color: sectionColors.parentSponsor, fontWeight: 'bold' }}>Parent Sponsor</span>}
                  layout="vertical"
                  size="small"
                >
                  <Descriptions.Item label={<strong>Consult ID</strong>}>{mlmUserParent_consultantId || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>First Name</strong>}>{mlmUserParent_firstName || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Second Name</strong>}>{mlmUserParent_secondName || "-"}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Self Points</strong>}>{mlmUserParent_selfEarnPoints}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Commission Points</strong>}>{mlmUserParent_contributePoints}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Group Points</strong>}>{mlmUserParent_totalBV}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Self BV</strong>}>{mlmUserParent_selfBV}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Commission BV</strong>}>{mlmUserParent_contributeBV}</Descriptions.Item>
                  <Descriptions.Item label={<strong>Group BV</strong>}>{mlmUserParent_groupBV}</Descriptions.Item>
                </Descriptions>

                <hr />

                <h4 style={{ color: sectionColors.teamMembers, fontWeight: 'bold' }}>Team Members List</h4>
                <Table
                  columns={childConsultantColumns}
                  dataSource={mlmUserChildConsult}
                  rowKey="consultantId"
                  bordered
                  size="small"
                  pagination={false}
                  scroll={{ x: 'max-content' }}
                />

              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <p>MLM User not found</p>
              </div>
            )}
          </Space>
        </div>
      </Content>
      <Footerdiv />
    </Layout>
  );
};

export default UserView;
